import React, { Component } from "react";
import Styles from './styles.module.css';
import { ReactComponent as LeftArrow } from '../../../Assets/svg/arrow-left.svg';
import { ReactComponent as RightArrow } from '../../../Assets/svg/arrow-right.svg';

const movie = '247482780';

export default class VideoSlide extends Component<any> {
    render() {
        const { index, image, current, prevoius, next, showArrows, ...props } = this.props;
        const arrows = this.renderArrows(current, index, showArrows);

        return (
            <div {...props} className={Styles.slideContent}>
                {arrows}
                <div className={Styles.slideImage} >
                        <iframe className={Styles.vimeoPlayer} src={`https://player.vimeo.com/video/${this.props.video}?title=0&byline=0&portrait=0&sidedock=0`} frameBorder="0" allowFullScreen />
                </div>
            </div>
        );
    }

    renderArrows = (current: number, slideIndex: number, showArrows: false) => {
        const isCurrent = current === slideIndex && showArrows;

        const arrows = (
            <>
                <div onClick={this.props.previous} className={Styles.leftArrow}>
                    <LeftArrow />
                </div>
                <div onClick={this.props.next} className={Styles.rightArrow}>
                    <RightArrow />
                </div>
            </>
        )

        return isCurrent ? arrows : <></>;
    }
}